import { render, staticRenderFns } from "./PurimTrackingDetails.vue?vue&type=template&id=502797a7&"
import script from "./PurimTrackingDetails.vue?vue&type=script&lang=js&"
export * from "./PurimTrackingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports